import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import classes from './MobileHome.scss';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import mobileFlighImage from './img/flights-mobile.svg';
import mobileHotelImage from './img/hotels-mobile.svg';
import mobileHolidayImage from './img/holidays-mobile.svg';
import mobileCabImage from './img/cabs-mobile.svg';

import * as uiActions from '../../../store/actions/index';
import RecentBooking from '../../RecentBooking/RecentBooking';

const mobileHome = (props) => {

    let recentBooking = false;

    let recentTrips = null;
    let upcomingTrips = null;
    let pastTrips = null;
    if (props.recentBooking !== null) {
        let recentBookingData = props.recentBooking.data.recentBookings.flight;
        if (recentBookingData.re.length === 0 &&  recentBookingData.up.length === 0 && recentBookingData.ps.length === 0) {
            recentBooking = false;
        } else {
            recentTrips = recentBookingData.re;
            upcomingTrips = recentBookingData.up;
            pastTrips = recentBookingData.ps;
            recentBooking = true;
        }
    }

    return (
        <div className={`u-phoneShow u-width100Percent u-height100Percent p-4`}>
            <main>
                <section className={'mb-6'}>
                    <div>
                        <HeadingH2 size={2.2} weight="Light" color="Light">Let's go somewhere</HeadingH2>
                        <HeadingH2 size={2.2} weight="Regular" color="Dark">You've never been before</HeadingH2>
                    </div>
                </section>
                <section className={'mb-6 u-relative'}>
                    <nav className={classes.Nav}>
                        <ul className={`u-flex justify-content-start align-items-center`}>
                            <li className={classes.NavItem} onClick={() => {
                                props.history.push('/flights');
                                props.onHideMobileHome();
                                }}>
                                <p className={`u-textColorLight u-fontWeightRegular u-fontSize13 u-textAlignCenter mb-2`}>Flights</p>
                                <div className={classes.NavImage}>
                                    <img src={mobileFlighImage} alt='Flight Mobile'/>
                                </div>
                            </li>
                            <li className={classes.NavItem} onClick={() => {
                                props.history.push('/hotels');
                                props.onHideMobileHome();
                            }}>
                                <p className={`u-textColorLight u-fontWeightRegular u-fontSize13 u-textAlignCenter mb-4`}>Hotel</p>
                                <div className={classes.NavImage}>
                                    <img src={mobileHotelImage} alt='Hotel Mobile'/>
                                </div>
                            </li>
                            <li className={classes.NavItem}>
                                <p className={`u-textColorLight u-fontWeightRegular u-fontSize13 u-textAlignCenter mb-4`}>Holiday</p>
                                <div className={classes.NavImage}>
                                    <img src={mobileHolidayImage} alt='Holiday Mobile'/>
                                </div>
                            </li>
                            <li className={classes.NavItem}>
                                <p className={`u-textColorLight u-fontWeightRegular u-fontSize13 u-textAlignCenter mb-4`}>Cabs</p>
                                <div className={classes.NavImage}>
                                    <img src={mobileCabImage} alt='Cab Mobile'/>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </section>
            </main>
            <section>
                {
                    recentBooking ? <div className={`mb-10 phone-mb-0`}>
                        <div className={`mb-4`}>
                            <HeadingH3 size={16} weight="Medium" color="Dark">Recent Bookings</HeadingH3>
                        </div>
                        <RecentBooking rt={recentTrips} ut={upcomingTrips} pt={pastTrips} />
                </div> : null
                }
            </section>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        recentBooking: state.auth.flightRecentBooking
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onHideMobileHome: () => dispatch(uiActions.hideMobileHome())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(mobileHome));


// WEBPACK FOOTER //
// ./src/components/Mobile/MobileHome/MobileHome.js